export default __webpack_public_path__ + "static/media/recording.632557fa.svg";